import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/copy.svg'


const _withScopeId = n => (_pushScopeId("data-v-35b4a78b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-flex-column" }
const _hoisted_2 = { class: "p-mt-6" }
const _hoisted_3 = { class: "p-mb-6" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-end abscissa-axis" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ordinate-axis" })
], -1))
const _hoisted_6 = {
  class: "p-d-flex p-jc-between",
  style: {"margin-top":"27px"}
}
const _hoisted_7 = { style: {"margin-left":"20px"} }
const _hoisted_8 = { class: "campaign-date" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "campaign-text" }, "Campaign Start", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "campaign-date"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "campaign-text" }, "Campaign Progress", -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "campaign-date" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "campaign-text" }, "Campaign Finish", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-pb-6" }, null, -1))
const _hoisted_17 = { class: "p-d-flex p-ai-center p-text-bold pointer" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "p-text-bold" }
const _hoisted_20 = { class: "p-text-bold" }
const _hoisted_21 = { class: "p-text-bold" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "p-pb-4 p-pl-3"
}, null, -1))
const _hoisted_24 = {
  key: 1,
  class: "p-mt-2"
}
const _hoisted_25 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_campaigns_list_counters_new = _resolveComponent("campaigns-list-counters-new")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_content_items_list = _resolveComponent("content-items-list")!
  const _component_short_campaign_page = _resolveComponent("short-campaign-page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          class: _normalizeClass([[_ctx.active === 0 ? 'red-board' : ''], "tabs"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.active = 0 )),
          label: "Campaign Stats"
        }, null, 8, ["class"]),
        _createVNode(_component_Button, {
          class: _normalizeClass([[_ctx.active === 1 ? 'red-board' : ''], "tabs"]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = 1)),
          label: "Live Content "
        }, null, 8, ["class"]),
        _createVNode(_component_Button, {
          class: _normalizeClass([[_ctx.active === 2 ? 'red-board' : ''], "tabs"]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active = 2)),
          label: "Campaign Preview"
        }, null, 8, ["class"])
      ])
    ]),
    (_ctx.active === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.filteredWorkers?.length)
            ? (_openBlock(), _createBlock(_component_campaigns_list_counters_new, {
                key: 0,
                counters: { views: _ctx.getStatisticsByRegion(_ctx.currentCampaign, _ctx.filteredWorkers)?.clicks,
           clicks: _ctx.getStatisticsByRegion(_ctx.currentCampaign, _ctx.filteredWorkers)?.clicks,
           android: _ctx.getStatisticsByRegion(_ctx.currentCampaign)?.android, ios: _ctx.getStatisticsByRegion(_ctx.currentCampaign)?.IOS}
              }, null, 8, ["counters"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "border-campaign",
            style: _normalizeStyle([{"max-width":"70vw","min-width":"15%"}, { width: _ctx.differenceout + '%'}])
          }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatDate(_ctx.currentCampaign?.dates?.startDate)), 1),
                _hoisted_9
              ]),
              (!_ctx.campaignFinished)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (!_ctx.campaignFinished)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(Math.round(_ctx.remDays, 1)) + " days left", 1))
                      : _createCommentVNode("", true),
                    _hoisted_12
                  ]))
                : _createCommentVNode("", true),
              (_ctx.campaignFinished)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.currentCampaign?.dates?.endDate) || '-'), 1),
                    _hoisted_15
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 4),
          _createVNode(_component_DataTable, {
            value: _ctx.filteredWorkers,
            responsiveLayout: "scroll",
            rows: 8,
            dataKey: "id",
            class: "p-mt-6"
          }, {
            empty: _withCtx(() => [
              _createTextVNode("No data found.")
            ]),
            loading: _withCtx(() => [
              _createTextVNode("Loading data... Please wait.")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                header: "Campaign Influencers",
                sortField: "number",
                class: "p-text-capitalize p-text-bold",
                style: {"color":"black"}
              }, {
                header: _withCtx(() => [
                  _hoisted_16
                ]),
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      src: data?.channel?.photo,
                      class: "channel-photo"
                    }, null, 8, _hoisted_18),
                    _createTextVNode(" " + _toDisplayString(data?.channel?.title), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "total clicks",
                sortField: "period"
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.findCurrentMetricsChannel(data?.channel?.channelId, _ctx.currentCampaign)?.clicks), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "TOTAL intalls",
                sortField: "status"
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.findCurrentMetricsChannel(data?.channel?.channelId, _ctx.currentCampaign)?.conversions), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "MONTHLY EARNINGS SO FAR",
                sortField: "status"
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.findCurrentMetricsChannel(data?.channel?.channelId, _ctx.currentCampaign)?.forPay?.total) + " " + _toDisplayString(_ctx.findCurrentMetricsChannel(data?.channel?.channelId, _ctx.currentCampaign)?.forPay?.currency), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Tracking Link",
                sortField: "status"
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.copyLink(_ctx.findCurrentMetricsChannel(data?.channel?.channelId, _ctx.currentCampaign)?.link)),
                    class: "p-d-flex link-text"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.currentCampaign?.trackingLink) + " ", 1),
                    _hoisted_23
                  ], 8, _hoisted_22)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.active === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_content_items_list, { items: _ctx.currentCampaignContent }, null, 8, ["items"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.active === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_short_campaign_page, {
            class: "p-grid p-col-11 p-m-auto",
            campaignInfo: _ctx.campaign,
            "short-preview": true,
            hideInfo: { isCampaignCPM: _ctx.campaign.paymentMethod ? true : false }
          }, null, 8, ["campaignInfo", "hideInfo"])
        ]))
      : _createCommentVNode("", true)
  ]))
}